import React, { Component } from 'react';
import _ from 'lodash';

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import Loading from '../Loading';

class SystemUsagesStatistic extends Component {
  constructor(props) {
    super(props);
  }

  _setTableOption(){ 
    if (_.isEmpty(this.props.results)) { 
      return "ไม่มีข้อมูล"; 
    }else{
      return <Loading />
    }
  }

  render(){
    var data = this.props.system_usages;

    const options = {
      sizePerPageList: [],
      sizePerPage: 25,
      noDataText: this._setTableOption()
    };
    return (
      <BootstrapTable 
        data={data}
        search={ true }
        multiColumnSearch={ true }
        options={options}
        striped
        hover
        condensed
        pagination
        version='4'
        tableContainerClass={'table-sm'}>
          <TableHeaderColumn isKey dataField='id' hidden></TableHeaderColumn>
            <TableHeaderColumn dataField='full_name' dataSort={ true } width='120px'>ชื่อ-สกุล</TableHeaderColumn>
            <TableHeaderColumn dataField='position' dataSort={ true }>ตำแหน่ง</TableHeaderColumn>
            <TableHeaderColumn dataField='department' dataSort={ true }>หน่วยงาน</TableHeaderColumn>
            <TableHeaderColumn dataField='amount' dataSort={ true }>จำนวนเข้าใช้ระบบ</TableHeaderColumn>
      </BootstrapTable>
    )
  }
}

export default SystemUsagesStatistic;



// WEBPACK FOOTER //
// ./src/components/reports/SystemUsagesStatistic.js